export default __webpack_public_path__ + "static/media/un-assign-action.33d06007.svg";